import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import LoginForm from "../../components/Auth/LoginForm";
import { useClient } from "../../hooks/client";
import config from "../../config";

const fallbackSrc = "logo.svg";

function Login() {
  const client = useClient();
  const { docsDomain, pageDomain } = config;

  const [imgSrc, set_imgSrc] = useState(fallbackSrc);

  useEffect(() => {
    document.title = `Shoppxy ${client.fullName ? `| ${client.fullName}` : ""}`;
  }, [client.fullName]);

  useEffect(() => {
    if (client.logo) {
      set_imgSrc(client.logo);
    }
  }, [client.logo]);

  const { key, status, loading } = client;

  return (
    <div className="nk-app-root">
      <div className="nk-main ">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content ">
            <div className="nk-split nk-split-page nk-split-lg">
              <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                  <a
                    href="#"
                    className="toggle btn-white btn btn-icon btn-light"
                    data-target="athPromo"
                  >
                    <em className="icon ni ni-info" />
                  </a>
                </div>
                <div className="nk-block nk-block-middle nk-auth-body">
                  <div className="brand-logo pb-5">
                    <a href="/" className="logo-link d-block">
                      <img
                        src={imgSrc}
                        className="logo-img logo-img-lg"
                        style={{
                          filter:
                            "invert(0.5) sepia(1) saturate(53) hue-rotate(235deg)",
                        }}
                        alt="logo"
                        onError={() => {
                          set_imgSrc(fallbackSrc);
                        }}
                      />
                      <img />
                    </a>
                    <span
                      className="text-muted"
                      style={{
                        fontSize: "smaller",
                        fontWeight: 600,
                      }}
                    >
                      Shoppxy.com
                    </span>
                  </div>

                  {loading ? (
                    <div className="nk-block-head">
                      <div className="nk-block-head-content">
                        <h5 className="nk-block-title">
                          <FormattedMessage id="Loading" />
                        </h5>
                        <div className="nk-block-des">
                          <p>
                            <FormattedMessage id="Please wait a moment" />
                            ...
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : key && status === "active" ? (
                    <>
                      <div className="nk-block-head">
                        <div className="nk-block-head-content">
                          <h5 className="nk-block-title">
                            <FormattedMessage id="Sign In" />
                          </h5>
                          <div className="nk-block-des">
                            <p>
                              <FormattedMessage id="Access the platform panel using your email and password." />
                            </p>
                          </div>
                        </div>
                      </div>
                      <LoginForm />
                    </>
                  ) : key && status === "inactive" ? (
                    <div>
                      <h3 className="text-danger">
                        <FormattedMessage id="Your account has been disabled" />
                      </h3>
                      <p className="text-danger">
                        <FormattedMessage id="Please contact your organization admin or reach out to our support team" />
                        .
                      </p>
                    </div>
                  ) : (
                    <div>
                      <h3>
                        <FormattedMessage id="You have to be part of an organization to login" />
                      </h3>
                      <p>
                        <FormattedMessage id="Please contact your organization admin to get the right link" />
                      </p>
                    </div>
                  )}

                  {/* <div className="form-note-s2 pt-4">
                    {" "}
                    New on our platform?{" "}
                    <a href="/demo2/pages/auths/auth-register.html">
                      Create an account
                    </a>
                  </div> */}
                  {/*  <div className="text-center pt-4 pb-3">
                    <h6 className="overline-title overline-title-sap">
                      <span>OR</span>
                    </h6>
                  </div>
                  <ul className="nav justify-center gx-4">
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Facebook
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Google
                      </a>
                    </li>
                  </ul> */}
                  {/* <div className="text-center mt-5">
                    <span className="fw-500">
                      I don't have an account? <a href="#">Try 15 days free</a>
                    </span>
                  </div> */}
                </div>
                <div className="nk-block nk-auth-footer">
                  <div className="nk-block-between">
                    <ul className="nav nav-sm">
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href={`${pageDomain}/terminos-y-condiciones#terminos-y-condiciones`}
                        >
                          <FormattedMessage id="Terms & Condition" />
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href={`${pageDomain}/terminos-y-condiciones#politica-de-privacidad`}
                        >
                          <FormattedMessage id="Privacy Policy" />
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href={`${docsDomain}/docs/guia-de-uso/negocios/iniciar-sesion`}
                        >
                          <FormattedMessage id="Help" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-3">
                    <p>
                      © {new Date().getFullYear()} Shoppxy.
                      <FormattedMessage id="All Rights Reserved" />.
                    </p>
                  </div>
                </div>
              </div>
              <PromoSlider />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function PromoSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Meaningful Shoppxy promotional messages
  const slides = [
    {
      titleId: "Complete E-commerce Solution",
      descriptionId:
        "Manage your entire online business with our comprehensive platform. From inventory management to order processing, we've got you covered.",
      iconElement: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 120 118"
          style={{ width: "7rem", height: "7rem", opacity: 0.8 }}
        >
          <path
            d="M8.916,94.745C-.318,79.153-2.164,58.569,2.382,40.578,7.155,21.69,19.045,9.451,35.162,4.32,46.609.676,58.716.331,70.456,1.845,84.683,3.68,99.57,8.694,108.892,21.408c10.03,13.679,12.071,34.71,10.747,52.054-1.173,15.359-7.441,27.489-19.231,34.494-10.689,6.351-22.92,8.733-34.715,10.331-16.181,2.192-34.195-.336-47.6-12.281A47.243,47.243,0,0,1,8.916,94.745Z"
            transform="translate(0 -1)"
            fill="#f6faff"
          />
          <rect
            x="18"
            y="32"
            width="84"
            height="50"
            rx="4"
            ry="4"
            fill="#fff"
          />
          <rect
            x="26"
            y="44"
            width="20"
            height="12"
            rx="1"
            ry="1"
            fill="#e5effe"
          />
          <rect
            x="50"
            y="44"
            width="20"
            height="12"
            rx="1"
            ry="1"
            fill="#e5effe"
          />
          <rect
            x="74"
            y="44"
            width="20"
            height="12"
            rx="1"
            ry="1"
            fill="#e5effe"
          />
          <rect
            x="38"
            y="60"
            width="20"
            height="12"
            rx="1"
            ry="1"
            fill="#e5effe"
          />
          <rect
            x="62"
            y="60"
            width="20"
            height="12"
            rx="1"
            ry="1"
            fill="#e5effe"
          />
          <path
            d="M98,32H22a5.006,5.006,0,0,0-5,5V79a5.006,5.006,0,0,0,5,5H52v8H45a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H73a2,2,0,0,0,2-2V94a2,2,0,0,0-2-2H66V84H98a5.006,5.006,0,0,0,5-5V37A5.006,5.006,0,0,0,98,32ZM73,94v4H45V94Zm-9-2H54V84H64Zm37-13a3,3,0,0,1-3,3H22a3,3,0,0,1-3-3V37a3,3,0,0,1,3-3H98a3,3,0,0,1,3,3Z"
            transform="translate(0 -1)"
            fill="#798bff"
          />
          <path
            d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z"
            transform="translate(0 -1)"
            fill="#6576ff"
          />
          <path
            d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z"
            transform="translate(0 -1)"
            fill="none"
            stroke="#6576ff"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            x1="40"
            y1="22"
            x2="57"
            y2="22"
            fill="none"
            stroke="#fffffe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            x1="40"
            y1="27"
            x2="57"
            y2="27"
            fill="none"
            stroke="#fffffe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            x1="40"
            y1="32"
            x2="50"
            y2="32"
            fill="none"
            stroke="#fffffe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            x1="30.5"
            y1="87.5"
            x2="30.5"
            y2="91.5"
            fill="none"
            stroke="#9cabff"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="28.5"
            y1="89.5"
            x2="32.5"
            y2="89.5"
            fill="none"
            stroke="#9cabff"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="79.5"
            y1="22.5"
            x2="79.5"
            y2="26.5"
            fill="none"
            stroke="#9cabff"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="77.5"
            y1="24.5"
            x2="81.5"
            y2="24.5"
            fill="none"
            stroke="#9cabff"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="90.5"
            cy="97.5"
            r="3"
            fill="none"
            stroke="#9cabff"
            strokeMiterlimit="10"
          />
          <circle
            cx="24"
            cy="23"
            r="2.5"
            fill="none"
            stroke="#9cabff"
            strokeMiterlimit="10"
          />
        </svg>
      ),
    },
    {
      titleId: "Advanced Analytics & Reports",
      descriptionId:
        "Make data-driven decisions with detailed sales reports, customer insights, and performance analytics to grow your business.",
      iconElement: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 90 90"
          style={{ width: "7rem", height: "7rem", opacity: 0.8 }}
        >
          <path
            d="M40.74,5.16l38.67,9.23a6,6,0,0,1,4.43,7.22L70.08,80a6,6,0,0,1-7.17,4.46L24.23,75.22A6,6,0,0,1,19.81,68L33.56,9.62A6,6,0,0,1,40.74,5.16Z"
            fill="#eff1ff"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            d="M50.59,6.5,11.18,11.73a6,6,0,0,0-5.13,6.73L13.85,78a6,6,0,0,0,6.69,5.16l39.4-5.23a6,6,0,0,0,5.14-6.73l-7.8-59.49A6,6,0,0,0,50.59,6.5Z"
            fill="#eff1ff"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <rect
            x="15"
            y="15"
            width="54"
            height="70"
            rx="6"
            ry="6"
            fill="#fff"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            x1="42"
            y1="77"
            x2="58"
            y2="77"
            fill="none"
            stroke="#c4cefe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <circle
            cx="38"
            cy="77"
            r="0.5"
            fill="#c4cefe"
            stroke="#c4cefe"
            strokeMiterlimit="10"
          />
          <line
            x1="42"
            y1="72"
            x2="58"
            y2="72"
            fill="none"
            stroke="#c4cefe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <circle
            cx="38"
            cy="72"
            r="0.5"
            fill="#c4cefe"
            stroke="#c4cefe"
            strokeMiterlimit="10"
          />
          <line
            x1="42"
            y1="66"
            x2="58"
            y2="66"
            fill="none"
            stroke="#c4cefe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <circle
            cx="38"
            cy="66"
            r="0.5"
            fill="#c4cefe"
            stroke="#c4cefe"
            strokeMiterlimit="10"
          />
          <path
            d="M46,40l-15-.3V40A15,15,0,1,0,46,25h-.36Z"
            fill="#e3e7fe"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            d="M42,22A14,14,0,0,0,28,36H42V22"
            fill="#e3e7fe"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <polyline
            points="33.47 30.07 28.87 23 23 23"
            fill="none"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <polyline
            points="25 56 35 56 40.14 49"
            fill="none"
            stroke="#6576ff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      ),
    },
    {
      titleId: "Seamless Customer Experience",
      descriptionId:
        "Provide your customers with a smooth shopping experience across all devices with our responsive and intuitive interface.",
      iconElement: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 90 90"
          style={{ width: "7rem", height: "7rem", opacity: 0.8 }}
        >
          <path
            d="M45,15c16.569,0,30,13.431,30,30s-13.431,30-30,30s-30-13.431-30-30S28.431,15,45,15z"
            fill="#e3e7fe"
            stroke="#6576ff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="45"
            cy="35"
            r="8"
            fill="#fff"
            stroke="#6576ff"
            strokeWidth="2"
          />
          <path
            d="M25,67c0-11.046,8.954-20,20-20s20,8.954,20,20"
            fill="none"
            stroke="#6576ff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32,25l4,4l8-8"
            fill="none"
            stroke="#6576ff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58,25l-4,4l-8-8"
            fill="none"
            stroke="#6576ff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="25" cy="25" r="2" fill="#9cabff" />
          <circle cx="65" cy="25" r="2" fill="#9cabff" />
          <path
            d="M20,45h10M60,45h10"
            stroke="#9cabff"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
  ];

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div
      className="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right toggle-screen-lg"
      data-toggle-body="true"
      data-content="athPromo"
      data-toggle-screen="lg"
      data-toggle-overlay="true"
    >
      <div
        className="slider-wrap w-100 p-3 p-sm-5 m-auto"
        style={{ maxWidth: "750px" }}
      >
        <div className="position-relative">
          {/* Slider Content */}
          <div className="slider-content">
            <div
              className="nk-feature nk-feature-center"
              style={{ maxWidth: "450px", margin: "0 auto" }}
            >
              {/* Images commented out as requested */}
              {/* <div className="nk-feature-img">
                 <img
                   className="round"
                   src="/path/to/your/image.png"
                   alt={slides[currentSlide].titleId}
                 />
               </div> */}

              {/* Custom SVG Icons */}
              <div className="nk-feature-img text-center mb-4">
                <div
                  className="feature-icon-wrap"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {slides[currentSlide].iconElement}
                </div>
              </div>

              <div className="nk-feature-content py-4 p-sm-5">
                <h5 className="mb-3">
                  <FormattedMessage id={slides[currentSlide].titleId} />
                </h5>
                <p className="text-muted">
                  <FormattedMessage id={slides[currentSlide].descriptionId} />
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <div
            className="slider-nav position-absolute"
            style={{ top: "50%", transform: "translateY(-50%)", left: "10px" }}
          >
            <button
              onClick={prevSlide}
              className="btn btn-light btn-sm rounded-circle"
              style={{ width: "40px", height: "40px" }}
            >
              <em className="icon ni ni-chevron-left"></em>
            </button>
          </div>
          <div
            className="slider-nav position-absolute"
            style={{ top: "50%", transform: "translateY(-50%)", right: "10px" }}
          >
            <button
              onClick={nextSlide}
              className="btn btn-light btn-sm rounded-circle"
              style={{ width: "40px", height: "40px" }}
            >
              <em className="icon ni ni-chevron-right"></em>
            </button>
          </div>

          {/* Dots Navigation */}
          <div className="slider-dots text-center mt-4">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`btn btn-sm rounded-circle mx-1 ${
                  currentSlide === index ? "btn-primary" : "btn-light"
                }`}
                style={{
                  width: "12px",
                  height: "12px",
                  padding: 0,
                  border: "none",
                }}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
